import type { CartPayments } from '../../domain/CartPayments';

import type { CartPaymentsRepository } from './../../domain/CartPaymentsRepository';

const getAlternativePayments = async (
  repository: CartPaymentsRepository
): Promise<CartPayments | null> => {
  return repository.get();
};

export default getAlternativePayments;
